import React from 'react';
import { connect } from 'react-redux';
import {
  getProjects,
  deleteProject as actionDeleteProject
} from '../../../actions/projects';
import { default as BaseModal } from 'react-bootstrap/lib/Modal';
import Tab from 'react-bootstrap/lib/Tab';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';

/*
 *  GUI Task Manager
 */

class Projects extends React.PureComponent {
  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(getProjects('python'));
  }

  deleteProject = (e, project) => {
    e.stopPropagation();
    if (
      window.confirm(
        `Вы уверены, что хотите удалить проект ${project.name}? Это необратимо.`
      )
    )
      this.props.dispatch(actionDeleteProject(project));
  };

  render() {
    const { projects, user, show, close } = this.props;
    const categories = [];

    if (projects) {
      projects.forEach(project => {
        const { category } = project;
        if (categories.indexOf(category) === -1) {
          categories.push(category);
        }
      });
    }
    categories.sort();

    return (
      <BaseModal show={show} onHide={close}>
        <BaseModal.Header closeButton>
          <div className="row">
            <div className="col-sm-3">
              <h4 className="modal-title" id="projectsLabel">
                Категории
              </h4>
            </div>
            <div className="col-sm-3 ">
              <h4 className="modal-title" id="projectsLabel">
                Проекты
              </h4>
            </div>
          </div>
        </BaseModal.Header>

        <BaseModal.Body>
          <Tab.Container id="left-tabs-example" defaultActiveKey="tab-Projects">
            <div className="row">
              <div
                className="col-sm-3"
                style={{
                  paddingLeft: '0px',
                  height: '360px',
                  borderRight: '1px solid #E5E5E5'
                }}
              >
                <Nav bsStyle="pills" stacked>
                  {categories.map(cat => (
                    <NavItem eventKey={`tab-${cat}`} key={`tab-${cat}-control`}>
                      {' '}
                      {cat}{' '}
                    </NavItem>
                  ))}
                </Nav>
              </div>

              <div className="col-sm-9 ">
                <Tab.Content
                  style={{ overflowX: 'hidden', height: '360px' }}
                  animation
                >
                  {categories.map(cat => (
                    <Tab.Pane
                      eventKey={`tab-${cat}`}
                      key={`tab-${cat}-content`}
                    >
                      {projects
                        .filter(p => p.category === cat)
                        .map((p, index) => (
                          <div
                            key={`project_${index}`}
                            className="highlight"
                            style={{
                              padding: '6px 3px 6px 0',
                              borderBottom: '1px solid #E5E5E5'
                            }}
                            onClick={() => {
                              this.props.loadProject(p);
                              close();
                            }}
                          >
                            {p.name}

                            {p.user === user.name && (
                              <button
                                className="btn btn-xs btn-link pull-right"
                                onClick={e => this.deleteProject(e, p)}
                              >
                                <i className="fa fa-times" aria-hidden="true" />
                              </button>
                            )}
                          </div>
                        ))}
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </div>
            </div>
          </Tab.Container>
        </BaseModal.Body>
      </BaseModal>
    );
  }
}

function mapStateToProps(state) {
  return { projects: state.projects.items };
}

export default connect(mapStateToProps)(Projects);
